import React, { FC } from "react"

import classes from "./Right.module.scss"

const Right: FC = ({ children }) => <p className={classes.Right}>{children}</p>
export default Right
